import { createContext, useContext } from 'react';
import type { CurrentUser } from '@lg/shared';

export interface AuthState {
  user: CurrentUser;
  /** Headers to attach to /api calls (bearer token or demo persona). */
  getAuthHeaders(): Promise<Record<string, string>>;
  /** Demo persona switch; only present in mock auth mode. */
  switchPersona?: () => void;
  signOut?: () => void;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthGate');
  return ctx;
}
